export const smoothScrollToElementWithId = (id: string) => {
  if (document.getElementById(id)) {
    const navHeight = 72
    window.scrollTo({
      top: document.getElementById(id).offsetTop - navHeight,
      behavior: "smooth",
    })
  } else {
    console.log(`id:${id} not found`)
  }
}
